import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { action: "" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-8" }
const _hoisted_4 = { class: "input-group mb-3" }
const _hoisted_5 = /*#__PURE__*/_createVNode("ion-icon", { name: "cloud-upload-outline" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Mulai Impor")
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = /*#__PURE__*/_createVNode("ion-icon", { name: "document-text-outline" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Download Template")
const _hoisted_10 = {
  key: 0,
  class: "row"
}
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "float-end" }
const _hoisted_17 = {
  key: 0,
  name: "save"
}
const _hoisted_18 = {
  key: 1,
  class: "fa fa-spinner fa-pulse"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Update Data ")
const _hoisted_20 = /*#__PURE__*/_createVNode("h4", null, "Data yang Akan Diperbarui", -1)
const _hoisted_21 = {
  key: 0,
  class: "row"
}
const _hoisted_22 = { class: "msg-box warning" }
const _hoisted_23 = {
  key: 1,
  class: "table table-borderless table-data"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("th", null, "No", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("th", null, "Tagihan", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("th", null, "Bulan", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("th", null, "NIS", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("th", null, "Nama Siswa", -1)
const _hoisted_29 = { class: "text-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      title: "Import Rincian Tagihan Siswa",
      link1: "Tagihan Siswa",
      link2: "Impor Rincian Tagihan Siswa"
    }),
    _createVNode("form", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("input", {
              type: "file",
              class: "form-control",
              id: "file",
              ref: "file",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleFileUpload()))
            }, null, 544),
            (_ctx.canCreate)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: "btn btn-outline-primary",
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.importDetail()))
                }, [
                  _hoisted_5,
                  _hoisted_6
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          (_ctx.canRead)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-outline-secondary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.templateImport()))
              }, [
                _hoisted_8,
                _hoisted_9
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.imported)
      ? (_openBlock(), _createBlock("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, [
                    _createVNode("div", _hoisted_16, [
                      (_ctx.canCreate || _ctx.canUpdate)
                        ? (_openBlock(), _createBlock("button", {
                            key: 0,
                            class: "btn btn-primary",
                            disabled: _ctx.processing,
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.applyImportDetail()))
                          }, [
                            (!_ctx.processing)
                              ? (_openBlock(), _createBlock("ion-icon", _hoisted_17))
                              : (_openBlock(), _createBlock("i", _hoisted_18)),
                            _hoisted_19
                          ], 8, ["disabled"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _hoisted_20,
                (_ctx.error_messages.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_21, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.error_messages, (message, i) => {
                        return (_openBlock(), _createBlock("div", _hoisted_22, _toDisplayString(message), 1))
                      }), 256))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.update_details.length > 0)
                  ? (_openBlock(), _createBlock("table", _hoisted_23, [
                      _createVNode("thead", null, [
                        _createVNode("tr", null, [
                          _hoisted_24,
                          _hoisted_25,
                          _hoisted_26,
                          _hoisted_27,
                          _hoisted_28,
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.update_details[0].bill_details, (val, key) => {
                            return (_openBlock(), _createBlock("th", null, _toDisplayString(_ctx.bill_details[key].name), 1))
                          }), 256))
                        ])
                      ]),
                      _createVNode("tbody", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.update_details, (data, i) => {
                          return (_openBlock(), _createBlock("tr", null, [
                            _createVNode("td", null, _toDisplayString(i+1), 1),
                            _createVNode("td", null, _toDisplayString(data.bill_name), 1),
                            _createVNode("td", null, _toDisplayString(_ctx.getMonthByID(data.month)), 1),
                            _createVNode("td", null, _toDisplayString(data.student_nis), 1),
                            _createVNode("td", null, _toDisplayString(data.student_name), 1),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(data.bill_details, (val, key) => {
                              return (_openBlock(), _createBlock("td", _hoisted_29, _toDisplayString(_ctx.toLocaleString(val)), 1))
                            }), 256))
                          ]))
                        }), 256))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}